import { TemplateCategory } from "./types";

export const imobiliarioCategory: TemplateCategory = {
  id: "imobiliario",
  name: "Direito Imobiliário",
  emoji: "🏘️",
  description: "Documentos para questões imobiliárias e possessórias",
  subcategories: [
    {
      id: "acoes-possessorias",
      name: "Ações Possessórias",
      emoji: "🏠",
      templates: [
        {
          id: "acao-usucapiao",
          name: "Ação de Usucapião",
          type: "Petição Inicial",
          description: "Modelo para ação de usucapião urbana ou rural",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

[NOME COMPLETO], [NACIONALIDADE], [PROFISSÃO], [ESTADO CIVIL], inscrito(a) no CPF sob o nº [NÚMERO], residente e domiciliado(a) na [ENDEREÇO COMPLETO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 1.238 e seguintes do Código Civil, propor a presente

AÇÃO DE USUCAPIÃO

em face de [NOME DOS PROPRIETÁRIOS/CONFRONTANTES], [QUALIFICAÇÃO COMPLETA], e em face do ESTADO DE [UF] e MUNICÍPIO DE [CIDADE], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O(a) requerente exerce posse mansa, pacífica e incontestada sobre o imóvel localizado na [ENDEREÇO COMPLETO DO IMÓVEL], com área de [ÁREA] m², há mais de [TEMPO] anos.

2. O imóvel possui as seguintes características:
   - Área: [ÁREA] m²
   - Confrontações: [DESCREVER CONFRONTAÇÕES]
   - Matrícula/Registro: [NÚMERO, SE HOUVER]
   - Dados do IPTU: [NÚMERO]

3. A posse teve início em [DATA], quando [DESCREVER COMO ADQUIRIU A POSSE].

4. Durante todo esse período, o(a) requerente:
   - Exerceu posse com ânimo de dono (animus domini)
   - Realizou benfeitorias no imóvel
   - Pagou impostos e taxas incidentes
   - Utilizou o imóvel para [FINALIDADE - moradia, cultivo, etc.]

5. A posse é mansa, pacífica, contínua e pública, sem oposição dos proprietários ou terceiros.

6. [DESCREVER OUTROS ELEMENTOS CARACTERIZADORES DA POSSE AD USUCAPIONEM]

7. Estão preenchidos todos os requisitos legais para a usucapião [ESPECIFICAR O TIPO].

II - DO DIREITO

O artigo 1.238 do Código Civil estabelece que "aquele que, por quinze anos, sem interrupção, nem oposição, possuir como seu um imóvel, adquire-lhe a propriedade".

[CITAR ARTIGOS ESPECÍFICOS CONFORME O TIPO DE USUCAPIÃO:
- Art. 1.239 CC (usucapião especial rural)
- Art. 1.240 CC (usucapião especial urbana)
- Art. 1.240-A CC (usucapião familiar)
- Art. 1.242 CC (usucapião ordinária)]

A posse ad usucapionem deve ser mansa, pacífica, contínua, pública e com animus domini, requisitos presentes no caso em tela.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação dos requeridos para, querendo, contestar a presente ação;
b) A citação dos confrontantes e terceiros interessados;
c) A publicação de editais na forma da lei;
d) A realização de perícia para demarcação da área;
e) A procedência dos pedidos para declarar a usucapião;
f) O registro da sentença no Cartório de Registro de Imóveis;
g) A condenação dos requeridos nos ônus da sucumbência;
h) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR VENAL DO IMÓVEL].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Planta/croqui do imóvel
- Certidões do Registro de Imóveis
- Comprovantes de pagamento de IPTU
- Fotos do imóvel
- Declarações de vizinhos
- Outros documentos comprobatórios da posse`
        },
        {
          id: "acao-imissao-posse",
          name: "Ação de Imissão na Posse",
          type: "Petição Inicial",
          description: "Modelo para ação de imissão na posse de imóvel",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

[NOME COMPLETO], [NACIONALIDADE], [PROFISSÃO], [ESTADO CIVIL], inscrito(a) no CPF sob o nº [NÚMERO], residente e domiciliado(a) na [ENDEREÇO COMPLETO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 1.228 do Código Civil, propor a presente

AÇÃO DE IMISSÃO NA POSSE

em face de [NOME DO POSSUIDOR], [QUALIFICAÇÃO COMPLETA], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O(a) requerente é legítimo(a) proprietário(a) do imóvel localizado na [ENDEREÇO COMPLETO], conforme matrícula nº [NÚMERO] do [CARTÓRIO DE REGISTRO DE IMÓVEIS].

2. O imóvel possui as seguintes características:
   - Área: [ÁREA] m²
   - Confrontações: [DESCREVER CONFRONTAÇÕES]
   - Valor venal: R$ [VALOR]
   - IPTU: [NÚMERO]

3. A propriedade foi adquirida por [FORMA DE AQUISIÇÃO - compra e venda, doação, herança, etc.] em [DATA], conforme [DOCUMENTO - escritura, formal de partilha, etc.].

4. O(a) requerido(a) encontra-se na posse do imóvel sem justo título ou autorização do proprietário.

5. O(a) requerente notificou extrajudicialmente o(a) requerido(a) em [DATA] para desocupação voluntária, mas este(a) permaneceu inerte.

6. [DESCREVER CIRCUNSTÂNCIAS DA OCUPAÇÃO INDEVIDA]

7. A posse exercida pelo(a) requerido(a) é injusta e precária.

8. O(a) requerente necessita do imóvel para [FINALIDADE].

II - DO DIREITO

O artigo 1.228 do Código Civil assegura ao proprietário o direito de usar, gozar e dispor da coisa, e o direito de reavê-la do poder de quem quer que injustamente a possua ou detenha.

A ação de imissão na posse é cabível quando o proprietário nunca teve a posse do bem ou quando a perdeu e pretende reavê-la.

A propriedade registrada confere ao titular o direito à posse, independentemente de sua efetiva detenção.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do(a) requerido(a) para, querendo, contestar a presente ação;
b) A concessão de liminar para imissão imediata na posse;
c) A procedência dos pedidos para confirmar a liminar;
d) A condenação do(a) requerido(a) ao pagamento de indenização por perdas e danos;
e) A condenação ao pagamento de aluguel pelo período de ocupação indevida;
f) A condenação nos ônus da sucumbência;
g) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR DO IMÓVEL].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Certidão de matrícula do imóvel
- Escritura de aquisição
- Notificação extrajudicial
- Comprovantes de propriedade
- Procuração`
        },
        {
          id: "acao-reintegracao-posse",
          name: "Ação de Reintegração de Posse",
          type: "Petição Inicial",
          description: "Modelo para ação de reintegração de posse",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

[NOME COMPLETO], [NACIONALIDADE], [PROFISSÃO], [ESTADO CIVIL], inscrito(a) no CPF sob o nº [NÚMERO], residente e domiciliado(a) na [ENDEREÇO COMPLETO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 560 do Código de Processo Civil, propor a presente

AÇÃO DE REINTEGRAÇÃO DE POSSE

em face de [NOME DO ESBULHADOR], [QUALIFICAÇÃO COMPLETA], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O(a) requerente exercia posse mansa, pacífica e incontestada sobre o imóvel localizado na [ENDEREÇO COMPLETO], há [TEMPO].

2. O imóvel possui as seguintes características:
   - Área: [ÁREA] m²
   - Confrontações: [DESCREVER CONFRONTAÇÕES]
   - Valor estimado: R$ [VALOR]
   - IPTU: [NÚMERO]

3. A posse era exercida com base em [TÍTULO - propriedade, contrato de locação, comodato, etc.].

4. Em [DATA DO ESBULHO], o(a) requerido(a) praticou esbulho possessório, [DESCREVER COMO OCORREU O ESBULHO].

5. O esbulho foi [CARACTERÍSTICA - violento, clandestino, precário], privando o(a) requerente injustamente da posse.

6. Houve notificação extrajudicial em [DATA] para cessação do esbulho, permanecendo o(a) requerido(a) inerte.

7. [DESCREVER PREJUÍZOS CAUSADOS PELO ESBULHO]

8. A presente ação é proposta dentro do prazo legal (menos de 1 ano e 1 dia do esbulho).

II - DO DIREITO

O artigo 560 do CPC estabelece que o possuidor tem direito a ser mantido na posse em caso de turbação e reintegrado no de esbulho.

O artigo 1.210 do Código Civil assegura ao possuidor o direito de ser mantido ou reintegrado na posse contra quem o moleste ou esbulhe.

Esbulho é a perda total da posse contra a vontade do possuidor, por violência, clandestinidade ou precariedade.

A ação possessória deve ser intentada dentro de ano e dia da turbação ou esbulho.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do(a) requerido(a) para, querendo, contestar a presente ação;
b) A concessão de liminar de reintegração de posse;
c) A procedência dos pedidos para confirmar a liminar;
d) A condenação em perdas e danos;
e) A condenação nos frutos e benfeitorias;
f) A cominação de multa diária em caso de descumprimento;
g) A condenação nos ônus da sucumbência;
h) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR DO IMÓVEL].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Documentos comprobatórios da posse
- Boletim de ocorrência (se houver)
- Notificação extrajudicial
- Fotografias do imóvel
- Testemunhas do esbulho
- Procuração`
        },
        {
          id: "interdito-proibitorio",
          name: "Interdito Proibitório",
          type: "Petição Inicial",
          description: "Modelo para interdito proibitório contra ameaça de turbação",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

[NOME COMPLETO], [NACIONALIDADE], [PROFISSÃO], [ESTADO CIVIL], inscrito(a) no CPF sob o nº [NÚMERO], residente e domiciliado(a) na [ENDEREÇO COMPLETO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 560 do Código de Processo Civil, propor o presente

INTERDITO PROIBITÓRIO

em face de [NOME DO TURBADOR], [QUALIFICAÇÃO COMPLETA], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O(a) requerente exerce posse mansa, pacífica e incontestada sobre o imóvel localizado na [ENDEREÇO COMPLETO], há [TEMPO].

2. O imóvel possui as seguintes características:
   - Área: [ÁREA] m²
   - Confrontações: [DESCREVER CONFRONTAÇÕES]
   - Valor estimado: R$ [VALOR]
   - IPTU: [NÚMERO]

3. A posse é exercida com base em [TÍTULO - propriedade, contrato, etc.] desde [DATA].

4. O(a) requerido(a) vem praticando atos que caracterizam ameaça à posse, tais como:
   [DESCREVER ATOS AMEAÇADORES]:
   - Construção de cerca no terreno
   - Invasão parcial da propriedade
   - Ameaças verbais de ocupação
   - Outros atos intimidatórios

5. Existe fundado receio de que o(a) requerido(a) venha a praticar turbação ou esbulho.

6. As ameaças são reais e iminentes, conforme [DESCREVER PROVAS].

7. A presente ação é proposta preventivamente para evitar a consumação da turbação.

II - DO DIREITO

O artigo 560 do CPC estabelece que o possuidor tem direito a ser mantido na posse em caso de turbação e reintegrado no de esbulho.

O interdito proibitório é ação possessória de caráter preventivo que visa evitar turbação ou esbulho iminente.

O artigo 1.210 do Código Civil assegura ao possuidor o direito de ser mantido na posse contra quem o moleste ou ameace molestar.

A jurisprudência admite o interdito quando há ameaça séria e fundada à posse.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do(a) requerido(a) para, querendo, contestar a presente ação;
b) A concessão de liminar para cessação imediata dos atos ameaçadores;
c) A procedência dos pedidos para confirmar a liminar;
d) A proibição de qualquer ato de turbação ou esbulho;
e) A cominação de multa diária em caso de descumprimento (R$ [VALOR]/dia);
f) A condenação em perdas e danos se configurada a turbação;
g) A condenação nos ônus da sucumbência;
h) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR DO IMÓVEL].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Documentos comprobatórios da posse
- Fotografias dos atos ameaçadores
- Testemunhas dos fatos
- Correspondências/notificações
- Boletim de ocorrência (se houver)
- Procuração`
        },
        {
          id: "acao-nunciacao-obra-nova",
          name: "Ação de Nunciação de Obra Nova",
          type: "Petição Inicial",
          description: "Modelo para embargar obra que prejudique imóvel vizinho",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

[NOME COMPLETO], [NACIONALIDADE], [PROFISSÃO], [ESTADO CIVIL], inscrito(a) no CPF sob o nº [NÚMERO], residente e domiciliado(a) na [ENDEREÇO COMPLETO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 566 do Código de Processo Civil, propor a presente

AÇÃO DE NUNCIAÇÃO DE OBRA NOVA

em face de [NOME DO CONSTRUTOR/PROPRIETÁRIO], [QUALIFICAÇÃO COMPLETA], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O(a) requerente é proprietário(a) do imóvel localizado na [ENDEREÇO COMPLETO], conforme matrícula nº [NÚMERO] do [CARTÓRIO DE REGISTRO DE IMÓVEIS].

2. O imóvel do(a) requerente possui as seguintes características:
   - Área: [ÁREA] m²
   - Confrontações: [DESCREVER CONFRONTAÇÕES]
   - IPTU: [NÚMERO]
   - Valor venal: R$ [VALOR]

3. O(a) requerido(a) iniciou obra em imóvel vizinho/confrontante localizado na [ENDEREÇO DA OBRA] em [DATA].

4. A referida obra vem causando ou ameaça causar prejuízos ao imóvel do(a) requerente, consistentes em:
   [DESCREVER PREJUÍZOS]:
   - Violação de recuos obrigatórios
   - Construção além dos limites do terreno
   - Obstrução de ventilação e iluminação
   - Infiltrações e danos estruturais
   - Violação de servidões
   - Descumprimento de posturas municipais

5. A obra está sendo executada [COM/SEM] licença municipal válida.

6. [DESCREVER TENTATIVAS DE SOLUÇÃO AMIGÁVEL]

7. A continuidade da obra causará danos irreparáveis ao imóvel do(a) requerente.

8. A presente ação é proposta dentro do prazo legal (ano e dia do início da obra).

II - DO DIREITO

O artigo 566 do CPC estabelece que compete a ação de nunciação de obra nova a quem se prejudica ou tem fundado receio de se prejudicar com obra nova.

O artigo 1.280 do Código Civil dispõe sobre as restrições ao direito de construir decorrentes da vizinhança.

A ação visa proteger os direitos de vizinhança e evitar danos decorrentes de construções irregulares.

O proprietário pode embargar obra nova que lhe cause ou ameace causar prejuízo.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do(a) requerido(a) para, querendo, contestar a presente ação;
b) A concessão de liminar para embargo imediato da obra;
c) A realização de perícia técnica para constatar os danos;
d) A procedência dos pedidos para tornar definitivo o embargo;
e) A demolição da parte irregular da obra;
f) A condenação em perdas e danos;
g) A cominação de multa diária em caso de descumprimento;
h) A condenação nos ônus da sucumbência;
i) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR DOS PREJUÍZOS].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Certidão de matrícula do imóvel
- Fotografias da obra e dos danos
- Plantas e projetos
- Alvará de construção (se houver)
- Laudo técnico (se disponível)
- Notificações extrajudiciais
- Procuração`
        },
        {
          id: "acao-dano-infecto",
          name: "Ação de Dano Infecto",
          type: "Petição Inicial",
          description: "Modelo para prevenir dano iminente causado por imóvel vizinho",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

[NOME COMPLETO], [NACIONALIDADE], [PROFISSÃO], [ESTADO CIVIL], inscrito(a) no CPF sob o nº [NÚMERO], residente e domiciliado(a) na [ENDEREÇO COMPLETO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 1.280 do Código Civil, propor a presente

AÇÃO DE DANO INFECTO

em face de [NOME DO VIZINHO/PROPRIETÁRIO], [QUALIFICAÇÃO COMPLETA], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O(a) requerente é proprietário(a) do imóvel localizado na [ENDEREÇO COMPLETO], conforme matrícula nº [NÚMERO] do [CARTÓRIO DE REGISTRO DE IMÓVEIS].

2. O imóvel do(a) requerente possui as seguintes características:
   - Área: [ÁREA] m²
   - Confrontações: [DESCREVER CONFRONTAÇÕES]
   - IPTU: [NÚMERO]
   - Valor venal: R$ [VALOR]

3. O(a) requerido(a) é proprietário(a) do imóvel vizinho/confrontante localizado na [ENDEREÇO DO IMÓVEL VIZINHO].

4. O imóvel do(a) requerido(a) apresenta situação de risco iminente que ameaça causar danos ao imóvel del(a) requerente:
   [DESCREVER A SITUAÇÃO DE RISCO]:
   - Construção em estado precário com risco de desabamento
   - Muro com rachaduras e risco de queda
   - Árvore de grande porte com risco de tombamento
   - Vazamentos que causam infiltrações
   - Acúmulo de materiais perigosos
   - Outras situações de perigo iminente

5. A situação foi constatada em [DATA] e [DESCREVER COMO FOI CONSTATADA].

6. Existe fundado receio de que o dano se concretize a qualquer momento, causando prejuízos materiais e pessoais.

7. O(a) requerente notificou extrajudicialmente o(a) requerido(a) em [DATA] sobre a situação de risco, sem obter resposta satisfatória.

8. [DESCREVER OUTRAS TENTATIVAS DE SOLUÇÃO]

II - DO DIREITO

O artigo 1.280 do Código Civil estabelece que o proprietário pode exigir do dono do prédio vizinho a demolição ou reparação necessária quando este ameace ruína.

O artigo 1.281 do Código Civil dispõe sobre o dever de indenizar quando o vizinho não atalha a ruína.

A ação de dano infecto visa prevenir danos decorrentes de situações de risco em imóveis vizinhos.

É princípio geral do direito que ninguém pode causar dano a outrem por ação ou omissão.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do(a) requerido(a) para, querendo, contestar a presente ação;
b) A concessão de liminar para realização imediata das obras/reparos necessários;
c) A realização de perícia técnica para avaliar o risco;
d) A procedência dos pedidos para condenar o(a) requerido(a) às obras necessárias;
e) A fixação de prazo para cumprimento da obrigação;
f) A cominação de multa diária em caso de descumprimento;
g) A autorização para o(a) requerente executar as obras às custas do(a) requerido(a);
h) A condenação nos ônus da sucumbência;
i) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR ESTIMADO DOS REPAROS].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Certidão de matrícula dos imóveis
- Fotografias da situação de risco
- Laudo técnico (se disponível)
- Notificação extrajudicial
- Boletim de ocorrência (se houver)
- Orçamentos das obras necessárias
- Procuração`
        }
      ]
    },
    {
      id: "locacao",
      name: "Locação",
      emoji: "🏢",
      templates: [
        {
          id: "acao-revisional-aluguel",
          name: "Ação Revisional de Aluguel",
          type: "Petição Inicial",
          description: "Modelo para ação revisional de valor de aluguel",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

[NOME COMPLETO], [NACIONALIDADE], [PROFISSÃO], [ESTADO CIVIL], inscrito(a) no CPF sob o nº [NÚMERO], residente e domiciliado(a) na [ENDEREÇO COMPLETO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 68 da Lei nº 8.245/91, propor a presente

AÇÃO REVISIONAL DE ALUGUEL

em face de [NOME DO LOCADOR/LOCATÁRIO], [QUALIFICAÇÃO COMPLETA], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. As partes celebraram contrato de locação em [DATA], tendo por objeto o imóvel localizado na [ENDEREÇO COMPLETO].

2. O imóvel possui as seguintes características:
   - Área: [ÁREA] m²
   - Finalidade: [RESIDENCIAL/COMERCIAL]
   - Valor atual do aluguel: R$ [VALOR]
   - Prazo de locação: [PRAZO]

3. O contrato foi celebrado pelo prazo de [PRAZO], com valor mensal de R$ [VALOR ORIGINAL].

4. Transcorridos [TEMPO] da locação, verifica-se que o valor do aluguel está [DEFASADO/EXCESSIVO] em relação aos praticados no mercado.

5. [DESCREVER MOTIVOS PARA A REVISÃO]:
   - Valorização/desvalorização imobiliária na região
   - Alterações nas condições do mercado
   - Benfeitorias realizadas no imóvel
   - Outros fatores relevantes

6. Tentativas de acordo amigável restaram infrutíferas.

7. A revisão é necessária para adequar o aluguel ao valor de mercado.

II - DO DIREITO

O artigo 68 da Lei 8.245/91 permite a revisão do valor do aluguel quando este se tornar desproporcional ao valor de mercado.

A ação revisional pode ser proposta após 3 anos de vigência do contrato ou do acordo anteriormente realizado.

O valor do aluguel deve corresponder ao preço de mercado do imóvel, considerando suas características e localização.

A jurisprudência do STJ admite a revisão quando comprovada a desproporção entre o valor praticado e o de mercado.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do(a) requerido(a) para, querendo, contestar a presente ação;
b) A realização de perícia para apuração do valor de mercado;
c) A procedência dos pedidos para [REDUZIR/AUMENTAR] o aluguel para R$ [VALOR PRETENDIDO];
d) A fixação de valor provisório durante o trâmite da ação;
e) A aplicação dos efeitos da revisão desde a citação;
f) A condenação nos ônus da sucumbência;
g) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR DA DIFERENÇA ANUAL].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Contrato de locação
- Comprovantes de pagamento
- Pesquisa de mercado
- Fotografias do imóvel
- Procuração`
        },
        {
          id: "acao-despejo",
          name: "Ação de Despejo",
          type: "Petição Inicial",
          description: "Modelo para ação de despejo por falta de pagamento",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

[NOME COMPLETO], [NACIONALIDADE], [PROFISSÃO], [ESTADO CIVIL], inscrito(a) no CPF sob o nº [NÚMERO], residente e domiciliado(a) na [ENDEREÇO COMPLETO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 9º da Lei nº 8.245/91, propor a presente

AÇÃO DE DESPEJO POR FALTA DE PAGAMENTO
C/C COBRANÇA DE ALUGUÉIS E ACESSÓRIOS

em face de [NOME DO LOCATÁRIO], [QUALIFICAÇÃO COMPLETA], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. As partes celebraram contrato de locação em [DATA], tendo por objeto o imóvel localizado na [ENDEREÇO COMPLETO].

2. O imóvel possui as seguintes características:
   - Área: [ÁREA] m²
   - Finalidade: [RESIDENCIAL/COMERCIAL]
   - Valor mensal do aluguel: R$ [VALOR]
   - Prazo de locação: [PRAZO]

3. O contrato prevê o pagamento do aluguel até o dia [DIA] de cada mês, bem como dos encargos locatícios.

4. O(a) requerido(a) encontra-se em mora desde [DATA], com os seguintes débitos em aberto:
   - Aluguéis: R$ [VALOR] ([PERÍODO])
   - Condomínio: R$ [VALOR] ([PERÍODO])
   - IPTU: R$ [VALOR] ([PERÍODO])
   - Multa contratual: R$ [VALOR]
   - Total do débito: R$ [VALOR TOTAL]

5. O(a) locatário(a) foi notificado(a) extrajudicialmente em [DATA] para purgar a mora no prazo legal, permanecendo inerte.

6. A mora é caracterizada e incontroversa, autorizando o despejo.

7. O inadimplemento persiste até a presente data.

II - DO DIREITO

O artigo 9º, inciso III, da Lei 8.245/91 estabelece que a locação também resolve-se pela falta de pagamento do aluguel e demais encargos.

O artigo 62, inciso I, da Lei do Inquilinato autoriza o despejo por falta de pagamento.

A mora é configurada pelo não pagamento no prazo avençado, independentemente de interpelação judicial.

O locador tem direito à retomada do imóvel quando o locatário deixa de cumprir suas obrigações contratuais.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do(a) requerido(a) para, em 15 dias, contestar a presente ação ou purgar a mora;
b) A procedência dos pedidos para declarar rescindido o contrato de locação;
c) A decretação do despejo com prazo de 30 dias para desocupação;
d) A condenação ao pagamento dos aluguéis e acessórios em atraso;
e) A condenação em aluguéis vencidos até a efetiva desocupação;
f) A condenação nos ônus da sucumbência;
g) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR DO DÉBITO + 12 ALUGUÉIS].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Contrato de locação
- Comprovantes do débito
- Notificação extrajudicial
- Demonstrativo dos valores
- Procuração`
        },
        {
          id: "acao-consignatoria-aluguel",
          name: "Ação Consignatória de Aluguel",
          type: "Petição Inicial",
          description: "Modelo para ação consignatória de pagamento de aluguel",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

[NOME COMPLETO], [NACIONALIDADE], [PROFISSÃO], [ESTADO CIVIL], inscrito(a) no CPF sob o nº [NÚMERO], residente e domiciliado(a) na [ENDEREÇO COMPLETO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 334 do Código Civil, propor a presente

AÇÃO CONSIGNATÓRIA DE PAGAMENTO DE ALUGUEL

em face de [NOME DO LOCADOR], [QUALIFICAÇÃO COMPLETA], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O(a) requerente é locatário(a) do imóvel localizado na [ENDEREÇO COMPLETO], conforme contrato de locação celebrado em [DATA].

2. O imóvel possui as seguintes características:
   - Área: [ÁREA] m²
   - Finalidade: [RESIDENCIAL/COMERCIAL]
   - Valor mensal do aluguel: R$ [VALOR]
   - Prazo de locação: [PRAZO]

3. O(a) requerente sempre foi pontual no pagamento dos aluguéis e demais obrigações contratuais.

4. [DESCREVER A CAUSA DA CONSIGNAÇÃO]:
   - O locador se recusa a receber o pagamento
   - O locador está em local incerto e não sabido
   - Existe dúvida sobre quem deve receber o pagamento
   - O locador exige valor superior ao contratado
   - Outras circunstâncias que impedem o pagamento

5. O(a) requerente tentou efetuar o pagamento em [DATA], mas não conseguiu devido à [CIRCUNSTÂNCIA].

6. Para evitar a configuração de mora, o(a) requerente vem consignar o valor devido.

7. O valor a ser consignado refere-se ao período de [PERÍODO] no montante de R$ [VALOR].

II - DO DIREITO

O artigo 334 do Código Civil estabelece que considera-se pagamento, e extingue-se a obrigação, o depósito judicial da coisa devida, nos casos e forma legais.

O artigo 335 do Código Civil permite a consignação quando o credor se recusa injustamente a receber o pagamento.

A consignação em pagamento é meio legítimo de o devedor se exonerar da obrigação quando há impedimento para o pagamento direto.

O objetivo da ação é evitar os efeitos da mora e demonstrar a boa-fé do devedor.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do(a) requerido(a) para, querendo, contestar a presente ação;
b) O depósito do valor devido (R$ [VALOR]) em conta judicial;
c) A procedência dos pedidos para declarar extinta a obrigação;
d) O levantamento do valor depositado pelo credor ou sua transferência;
e) A condenação do réu nos ônus da sucumbência (se houver resistência injustificada);
f) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR CONSIGNADO].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Contrato de locação
- Comprovantes de tentativa de pagamento
- Recibos de aluguéis anteriores
- Correspondências trocadas
- Procuração`
        }
      ]
    },
    {
      id: "contratos-imobiliarios",
      name: "Contratos Imobiliários",
      emoji: "📋",
      templates: [
        {
          id: "acao-rescisao-contratual-compra-venda",
          name: "Ação de Rescisão Contratual de Compra e Venda",
          type: "Petição Inicial",
          description: "Modelo para ação de rescisão de contrato de compra e venda de imóvel",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

[NOME COMPLETO], [NACIONALIDADE], [PROFISSÃO], [ESTADO CIVIL], inscrito(a) no CPF sob o nº [NÚMERO], residente e domiciliado(a) na [ENDEREÇO COMPLETO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 475 do Código Civil, propor a presente

AÇÃO DE RESCISÃO CONTRATUAL DE COMPRA E VENDA

em face de [NOME DA PARTE CONTRÁRIA], [QUALIFICAÇÃO COMPLETA], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. As partes celebraram contrato de promessa de compra e venda em [DATA], tendo por objeto o imóvel localizado na [ENDEREÇO COMPLETO].

2. O imóvel possui as seguintes características:
   - Área: [ÁREA] m²
   - Matrícula: [NÚMERO] do [CARTÓRIO]
   - Valor do contrato: R$ [VALOR]
   - Forma de pagamento: [DESCREVER]

3. Conforme cláusulas contratuais, o(a) requerido(a) se obrigou a:
   [LISTAR OBRIGAÇÕES ASSUMIDAS]

4. O(a) requerente cumpriu integralmente suas obrigações contratuais, [DESCREVER CUMPRIMENTO].

5. Contudo, o(a) requerido(a) descumpriu o contrato ao:
   [DESCREVER INADIMPLEMENTO ESPECÍFICO]:
   - Não efetuar pagamentos nas datas avençadas
   - Não entregar a documentação necessária
   - Não proceder ao registro da escritura
   - Outras violações contratuais

6. O inadimplemento persiste desde [DATA], caracterizando mora.

7. Houve notificação extrajudicial em [DATA] para purgar a mora, permanecendo o(a) requerido(a) inerte.

8. O descumprimento contratual tornou impossível a manutenção do negócio jurídico.

II - DO DIREITO

O artigo 475 do Código Civil estabelece que a parte lesada pelo inadimplemento pode pedir a resolução do contrato, se não preferir exigir-lhe o cumprimento.

O artigo 1.418 do Código Civil dispõe sobre o direito de resolução nos contratos de compra e venda.

O inadimplemento de obrigação contratual autoriza a parte inocente a pleitear a rescisão.

A mora do devedor caracteriza-se pelo não cumprimento da prestação no tempo, lugar e forma convencionados.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do(a) requerido(a) para, querendo, contestar a presente ação;
b) A procedência dos pedidos para declarar rescindido o contrato;
c) A condenação à restituição dos valores pagos, devidamente corrigidos;
d) A condenação em perdas e danos;
e) A liberação de eventuais gravames sobre o imóvel;
f) A condenação nos ônus da sucumbência;
g) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR DO CONTRATO].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Contrato de compra e venda
- Comprovantes de pagamento
- Notificação extrajudicial
- Documentos do imóvel
- Correspondências entre as partes
- Procuração`
        },
        {
          id: "acao-adjudicacao-compulsoria",
          name: "Ação de Adjudicação Compulsória",
          type: "Petição Inicial",
          description: "Modelo para compelir vendedor a outorgar escritura definitiva",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

[NOME COMPLETO], [NACIONALIDADE], [PROFISSÃO], [ESTADO CIVIL], inscrito(a) no CPF sob o nº [NÚMERO], residente e domiciliado(a) na [ENDEREÇO COMPLETO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 1.418 do Código Civil, propor a presente

AÇÃO DE ADJUDICAÇÃO COMPULSÓRIA

em face de [NOME DO VENDEDOR], [QUALIFICAÇÃO COMPLETA], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. As partes celebraram contrato de promessa de compra e venda em [DATA], tendo por objeto o imóvel localizado na [ENDEREÇO COMPLETO].

2. O imóvel possui as seguintes características:
   - Área: [ÁREA] m²
   - Matrícula: [NÚMERO] do [CARTÓRIO]
   - Valor do contrato: R$ [VALOR]
   - Situação: [URBANO/RURAL]

3. Pelo referido contrato, o(a) requerido(a) se obrigou a vender o imóvel ao(a) requerente mediante o pagamento de [FORMA DE PAGAMENTO].

4. O(a) requerente cumpriu integralmente todas as suas obrigações contratuais:
   [DESCREVER CUMPRIMENTO]:
   - Pagamento integral do preço
   - Pagamento de impostos e taxas
   - Cumprimento de outras obrigações assumidas

5. Apesar do cumprimento das obrigações pelo(a) comprador(a), o(a) requerido(a) se recusa a outorgar a escritura definitiva de compra e venda.

6. O(a) requerente notificou extrajudicialmente o(a) requerido(a) em [DATA] para cumprimento da obrigação, permanecendo este(a) inerte.

7. [DESCREVER OUTRAS TENTATIVAS DE SOLUÇÃO]

8. A recusa é injustificada, uma vez que todas as condições contratuais foram cumpridas.

9. O(a) requerente tem direito adquirido à propriedade do imóvel.

II - DO DIREITO

O artigo 1.418 do Código Civil estabelece que o promitente comprador, titular de direitos reais, pode exigir do promitente vendedor o cumprimento do contrato.

O artigo 16 do Decreto-Lei 58/37 assegura ao adquirente o direito de adjudicar o imóvel quando cumpridas as obrigações contratuais.

A adjudicação compulsória é direito do promissário comprador quando há recusa injustificada do vendedor em outorgar escritura.

O cumprimento do contrato pelo comprador gera direito adquirido à propriedade.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do(a) requerido(a) para, querendo, contestar a presente ação;
b) A procedência dos pedidos para condenar o(a) requerido(a) a outorgar escritura;
c) Alternativamente, que a sentença sirva como título para registro;
d) A condenação ao pagamento de perdas e danos;
e) A condenação ao pagamento dos impostos de transmissão;
f) A liberação do imóvel de eventuais ônus posteriores ao contrato;
g) A condenação nos ônus da sucumbência;
h) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR DO IMÓVEL].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Contrato de promessa de compra e venda
- Comprovantes de pagamento
- Certidão de matrícula do imóvel
- Notificação extrajudicial
- Correspondências entre as partes
- Procuração`
        }
      ]
    },
    {
      id: "condominio-demarcacao",
      name: "Condomínio e Demarcação",
      emoji: "🏘️",
      templates: [
        {
          id: "acao-cobranca-taxas-condominiais",
          name: "Ação de Cobrança de Taxas Condominiais",
          type: "Petição Inicial",
          description: "Modelo para ação de cobrança de taxas condominiais",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

[NOME DO CONDOMÍNIO], pessoa jurídica de direito privado, inscrito no CNPJ sob o nº [NÚMERO], com sede na [ENDEREÇO COMPLETO], neste ato representado por seu síndico [NOME DO SÍNDICO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 1.336 do Código Civil, propor a presente

AÇÃO DE COBRANÇA DE TAXAS CONDOMINIAIS

em face de [NOME DO CONDÔMINO], [QUALIFICAÇÃO COMPLETA], proprietário(a) da unidade [NÚMERO/DESCRIÇÃO], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O(A) requerido(a) é proprietário(a) da unidade autônoma [NÚMERO/DESCRIÇÃO], localizada no condomínio [NOME], conforme matrícula nº [NÚMERO].

2. O condomínio foi instituído através de [CONVENÇÃO/ATA] em [DATA], devidamente registrada.

3. A convenção condominial estabelece a obrigação de pagamento de taxas mensais para custeio das despesas comuns.

4. O valor atual da taxa condominial é de R$ [VALOR] mensais, aprovado em assembleia.

5. O(A) requerido(a) encontra-se inadimplente com as seguintes taxas:
   - Período: [PERÍODO]
   - Valor principal: R$ [VALOR]
   - Multa contratual: R$ [VALOR]
   - Juros de mora: R$ [VALOR]
   - Correção monetária: R$ [VALOR]
   - Total do débito: R$ [VALOR TOTAL]

6. O condômino foi notificado extrajudicialmente em [DATA] para pagamento, permanecendo inerte.

7. As despesas condominiais são necessárias para manutenção e conservação das áreas comuns.

8. O inadimplemento prejudica a administração do condomínio.

II - DO DIREITO

O artigo 1.336, inciso I, do Código Civil estabelece a obrigação do condômino de contribuir para as despesas do condomínio na proporção de suas frações ideais.

O artigo 1.348 do Código Civil dispõe sobre a responsabilidade pelas despesas condominiais.

A Lei 4.591/64 regulamenta os condomínios e estabelece as obrigações dos condôminos.

As taxas condominiais têm natureza propter rem, acompanhando o imóvel independentemente de quem seja o proprietário.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação do(a) requerido(a) para, querendo, contestar a presente ação;
b) A procedência dos pedidos para condenar ao pagamento do débito;
c) A condenação ao pagamento de taxas vencidas até o trânsito em julgado;
d) A aplicação de multa, juros e correção monetária;
e) A condenação nos ônus da sucumbência;
f) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR TOTAL DO DÉBITO].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Convenção condominial
- Certidão de matrícula do imóvel
- Demonstrativo de débito
- Ata de assembleia (se houver alteração de valores)
- Notificação extrajudicial
- Procuração`
        },
        {
          id: "acao-demarcacao-terras",
          name: "Ação de Demarcação de Terras",
          type: "Petição Inicial",
          description: "Modelo para ação demarcatória de terras",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

[NOME COMPLETO], [NACIONALIDADE], [PROFISSÃO], [ESTADO CIVIL], inscrito(a) no CPF sob o nº [NÚMERO], residente e domiciliado(a) na [ENDEREÇO COMPLETO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 1.297 do Código Civil, propor a presente

AÇÃO DE DEMARCAÇÃO DE TERRAS

em face de [NOME DOS CONFRONTANTES], [QUALIFICAÇÃO COMPLETA], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. O(A) requerente é legítimo(a) proprietário(a) do imóvel rural denominado [NOME DA PROPRIEDADE], localizado na [ENDEREÇO/LOCALIZAÇÃO COMPLETA].

2. O imóvel possui as seguintes características:
   - Área: [ÁREA] hectares
   - Matrícula: [NÚMERO] do [CARTÓRIO]
   - Valor venal: R$ [VALOR]
   - ITR: [NÚMERO]

3. A propriedade foi adquirida por [FORMA DE AQUISIÇÃO] em [DATA], conforme [DOCUMENTO].

4. Existem dúvidas quanto aos limites exatos da propriedade, especialmente nas divisas com os imóveis dos requeridos.

5. [DESCREVER A SITUAÇÃO DOS LIMITES]:
   - Marcos divisórios foram removidos ou desapareceram
   - Existe ocupação além dos limites
   - Confrontantes contestam as divisas
   - Medições antigas são imprecisas

6. A demarcação é necessária para:
   - Definir exatamente os limites da propriedade
   - Evitar conflitos futuros
   - Permitir aproveitamento adequado da terra
   - Regularizar a situação documental

7. Tentativas de acordo amigável restaram infrutíferas.

II - DO DIREITO

O artigo 1.297 do Código Civil assegura ao proprietário o direito de cercar, murar, valar ou tapar de qualquer modo o seu prédio, urbano ou rural.

O artigo 1.298 do Código Civil estabelece que sendo confusos, os limites, em falta de outro meio, se determinarão de conformidade com a posse justa.

A ação demarcatória visa estabelecer os limites entre propriedades contíguas quando há incerteza sobre as divisas.

É direito do proprietário conhecer exatamente os limites de sua propriedade.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação dos requeridos para, querendo, contestar a presente ação;
b) A nomeação de perito para demarcação das terras;
c) A procedência dos pedidos para fixar definitivamente os limites;
d) A colocação de marcos divisórios permanentes;
e) A lavratura de auto de demarcação;
f) A averbação da demarcação na matrícula do imóvel;
g) A condenação nos ônus da sucumbência;
h) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR DO IMÓVEL].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Certidão de matrícula do imóvel
- Escritura de aquisição
- Plantas e memoriais descritivos
- Fotografias aéreas
- Documento de ITR
- Procuração`
        },
        {
          id: "acao-divisao-coisa-comum",
          name: "Ação de Divisão de Coisa Comum",
          type: "Petição Inicial",
          description: "Modelo para ação de divisão de bem comum",
          icon: "FileText",
          content: `EXCELENTÍSSIMO(A) SENHOR(A) DOUTOR(A) JUIZ(A) DE DIREITO DA ___ª VARA CÍVEL DA COMARCA DE _____________

[NOME COMPLETO], [NACIONALIDADE], [PROFISSÃO], [ESTADO CIVIL], inscrito(a) no CPF sob o nº [NÚMERO], residente e domiciliado(a) na [ENDEREÇO COMPLETO], vem, respeitosamente, perante Vossa Excelência, por meio de seu advogado infra-assinado, com base no artigo 1.320 do Código Civil, propor a presente

AÇÃO DE DIVISÃO DE COISA COMUM

em face de [NOME DOS COPROPRIETÁRIOS], [QUALIFICAÇÃO COMPLETA], pelos fatos e fundamentos jurídicos a seguir expostos:

I - DOS FATOS

1. As partes são coproprietárias do imóvel localizado na [ENDEREÇO COMPLETO], conforme matrícula nº [NÚMERO] do [CARTÓRIO].

2. O imóvel possui as seguintes características:
   - Área total: [ÁREA] m²
   - Valor venal: R$ [VALOR]
   - IPTU: [NÚMERO]
   - Situação: [URBANO/RURAL]

3. A copropriedade teve origem em [CAUSA - herança, aquisição conjunta, etc.] em [DATA].

4. As frações ideais de cada coproprietário são:
   - [NOME]: [PERCENTUAL]%
   - [NOME]: [PERCENTUAL]%
   - [OUTROS COPROPRIETÁRIOS]

5. [DESCREVER A SITUAÇÃO ATUAL]:
   - Impossibilidade de acordo para venda
   - Conflitos sobre uso e administração
   - Deterioração do bem por falta de consenso
   - Necessidade de cada condômino dispor de sua parte

6. O(A) requerente tentou acordo amigável para divisão ou venda, sem êxito.

7. A divisão é a melhor solução para pôr fim ao estado de indivisão.

8. [AVALIAR SE O BEM É DIVISÍVEL OU INDIVISÍVEL]

II - DO DIREITO

O artigo 1.320 do Código Civil estabelece que a todo tempo será lícito ao condômino exigir a divisão da coisa comum.

O artigo 1.322 do Código Civil dispõe sobre os procedimentos para divisão quando há acordo ou oposição.

Quando a coisa não admite divisão cômoda, deve ser vendida e repartido o preço.

Ninguém pode ser obrigado a permanecer na comunhão, exceto nos casos previstos em lei.

III - DOS PEDIDOS

Ante o exposto, requer-se:

a) A citação dos requeridos para, querendo, contestar a presente ação;
b) A nomeação de perito para avaliação e verificação da possibilidade de divisão;
c) Se divisível, a divisão do imóvel em partes proporcionais às quotas;
d) Se indivisível, a venda judicial e repartição do preço;
e) A lavratura de auto de divisão ou adjudicação;
f) A averbação da divisão nas matrículas;
g) A condenação nos ônus da sucumbência;
h) Os demais pedidos de direito.

Dá-se à causa o valor de R$ [VALOR DO IMÓVEL].

Termos em que,
Pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO ADVOGADO]
OAB/[UF] [NÚMERO]

DOCUMENTOS ANEXOS:
- Certidão de matrícula do imóvel
- Documento de origem da copropriedade
- Comprovante de pagamento de IPTU
- Fotografias do imóvel
- Correspondências entre os condôminos
- Procuração`
        }
      ]
    }
  ]
};
